import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  Button,
  Divider,
  Footer,
  Icon,
  KCol,
  KPanel,
  KRow,
  KTable,
  KTableColumn,
  KTableHeader,
  KTableRow,
  Label,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { KuikaTabOrderProvider } from "../../shared/hoc/tab-order-provider";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { OrderSummary_ScreenBase } from "./ordersummary-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class OrderSummary_Screen extends OrderSummary_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <KuikaTabOrderProvider>
            <Form
              form={this.props.form}
              name="basic"
              component={false}
              initialValues={{}}
              onValuesChange={(changedValues, allValues) => {
                this.clearFieldValidation(changedValues);
              }}
            >
              <div
                style={
                  {
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100%",
                  } as any
                }
              >
                <div
                  key="-1"
                  id="ordersummary_body"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "#F5F7FB",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      paddingTop: 16,
                      paddingRight: 16,
                      paddingBottom: 16,
                      paddingLeft: 16,
                      display: "block",
                      overflow: "auto",
                      minHeight:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                      maxHeight:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                      height:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                    } as any
                  }
                >
                  <KRow
                    key="623640"
                    id="623640"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                      } as any
                    }
                  >
                    <KCol
                      key="502357"
                      id="502357"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                        } as any
                      }
                    >
                      <KRow
                        key="23439"
                        id="23439"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingLeft: 0,
                          } as any
                        }
                      >
                        <KCol
                          key="858813"
                          id="858813"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                            } as any
                          }
                        >
                          <VerticalStack
                            key="254777"
                            id="254777"
                            direction="vertical"
                            size={8}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Label
                              key="897348"
                              id="897348"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                897348,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  display: "block",
                                  fontFamily: "Montserrat",
                                  fontWeight: 700,
                                  fontSize: "26px",
                                  color: "#0F172A",
                                } as any
                              }
                            ></Label>
                            <Label
                              key="665149"
                              id="665149"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                665149,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  display: "block",
                                  fontFamily: "Roboto",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  color: "#64748B",
                                } as any
                              }
                            ></Label>
                          </VerticalStack>
                        </KCol>
                      </KRow>
                      <KRow
                        key="355050"
                        id="355050"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                          } as any
                        }
                      >
                        <KCol
                          key="93384"
                          id="93384"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                            } as any
                          }
                        >
                          <KTable
                            key="987972"
                            id="987972"
                            kuikaRef={
                              this.ordersummary_987972_value_kuikaTableRef
                            }
                            form={this.props.form}
                            dataSource={this.state.dataSource_987972}
                            size="middle"
                            bordered={true}
                            loading={false}
                            rowKey="id"
                            transformedOnMobileResolution={false}
                            hideHeaderOnMobileResolution={false}
                            showHeader={false}
                            fixedHeader={false}
                            tableWidthMode="fit"
                            editable={false}
                            editableAlwaysActive={false}
                            insertRowActive={false}
                            insertRowPosition="top"
                            globalSearch={false}
                            searchable={false}
                            shouldSearchOnChange={true}
                            searchDelay={200}
                            sorter={false}
                            filtering={false}
                            resizableColumns={false}
                            pagination={false}
                            pageSize={10}
                            showSizeChanger={false}
                            paginationSelectedTextColor="#246eff"
                            paginationUnselectedTextColor="#000"
                            columnChooser={false}
                            striped={false}
                            stripedColor="#F5F7FA"
                            rowHoverBgColor="#fafafa"
                            showRowNumbers={false}
                            showNoDataFound={true}
                            nodatafoundmessage={ReactSystemFunctions.translate(
                              this.ml,
                              987972,
                              "nodatafoundmessage",
                              this.defaultML
                            )}
                            multiSelect={false}
                            multiSelectScope="page"
                            export={false}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KTableHeader
                              key="824381"
                              id="824381"
                              hideOnMobileResolution={false}
                              textDirection="Default"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  color: "rgba(155, 155, 155, 1)",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></KTableHeader>
                            <KTableRow
                              key="364299"
                              id="364299"
                              hoverFontColor="red"
                              hoverBgColor="#F5F5F5"
                              style={
                                {
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KTableColumn
                                key="214323"
                                id="214323"
                                title={ReactSystemFunctions.translate(
                                  this.ml,
                                  214323,
                                  "title",
                                  this.defaultML
                                )}
                                alwaysVisibleOnMobileResolution={false}
                                hideFiltering={false}
                                hideSorting={false}
                                hideSearch={false}
                                footerOptions="none"
                                footerFontSize={14}
                                footerFontColor="rgb(68, 68, 68)"
                                excludeFromExport={false}
                                footerFontWeight="Regular"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KPanel
                                  key="725569"
                                  id="725569"
                                  scrolling="hidden"
                                  scrollRadius={false}
                                  style={
                                    {
                                      borderTopLeftRadius: 18,
                                      borderTopRightRadius: 18,
                                      borderBottomRightRadius: 18,
                                      borderBottomLeftRadius: 18,
                                      borderTopWidth: 1,
                                      borderRightWidth: 1,
                                      borderBottomWidth: 1,
                                      borderLeftWidth: 1,
                                      borderColor: "#E2E8F0",
                                      borderStyle: "solid",
                                      boxShadow:
                                        "0px 10px 24px 0px rgba(15,23,42,0.08)",
                                      backgroundColor: "#FFFFFF",
                                      paddingTop: 16,
                                      paddingRight: 16,
                                      paddingBottom: 16,
                                      paddingLeft: 16,
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="903968"
                                    id="903968"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="89440"
                                      id="89440"
                                      xs={24}
                                      sm={3}
                                      md={3}
                                      lg={3}
                                      xl={3}
                                      xxl={3}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <Icon
                                        key="574274"
                                        id="574274"
                                        iconName="view_in_ar"
                                        iconLibrary="material"
                                        style={
                                          {
                                            borderTopLeftRadius: 8,
                                            borderTopRightRadius: 8,
                                            borderBottomRightRadius: 8,
                                            borderBottomLeftRadius: 8,
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            backgroundColor:
                                              "rgba(68, 142, 247, 0.2)",
                                            paddingTop: 18,
                                            paddingRight: 18,
                                            paddingBottom: 18,
                                            paddingLeft: 18,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "32px",
                                            color: "rgba(68, 142, 247, 1)",
                                            letterSpacing: "1px",
                                          } as any
                                        }
                                      ></Icon>
                                    </KCol>
                                    <KCol
                                      key="901293"
                                      id="901293"
                                      xs={24}
                                      sm={21}
                                      md={21}
                                      lg={21}
                                      xl={21}
                                      xxl={21}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                        } as any
                                      }
                                    >
                                      <KRow
                                        key="825559"
                                        id="825559"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="304930"
                                          id="304930"
                                          xs={20}
                                          sm={20}
                                          md={20}
                                          lg={20}
                                          xl={20}
                                          xxl={20}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="231954"
                                            id="231954"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              231954,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                display: "block",
                                                fontFamily: "Montserrat",
                                                fontWeight: 700,
                                                fontSize: "16px",
                                                color: "#0F172A",
                                              } as any
                                            }
                                          ></Label>
                                          <Label
                                            key="88901"
                                            id="88901"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              88901,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 4,
                                                display: "block",
                                                fontFamily: "Roboto",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                                color: "#94A3B8",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="221270"
                                          id="221270"
                                          xs={4}
                                          sm={4}
                                          md={4}
                                          lg={4}
                                          xl={4}
                                          xxl={4}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Button
                                            key="957853"
                                            id="957853"
                                            label={ReactSystemFunctions.translate(
                                              this.ml,
                                              957853,
                                              "label",
                                              this.defaultML
                                            )}
                                            size="middle"
                                            loading={false}
                                            ghost={false}
                                            block={false}
                                            htmlType="button"
                                            icon="delete"
                                            iconPosition="left"
                                            danger={false}
                                            iconLibrary="material"
                                            style={
                                              {
                                                borderTopLeftRadius: 12,
                                                borderTopRightRadius: 12,
                                                borderBottomRightRadius: 12,
                                                borderBottomLeftRadius: 12,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor: "#E2E8F0",
                                                borderStyle: "solid",
                                                backgroundColor: "#FFFFFF",
                                                paddingTop: 8,
                                                paddingRight: 10,
                                                paddingBottom: 8,
                                                paddingLeft: 10,
                                                color: "rgba(225, 60, 57, 1)",
                                              } as any
                                            }
                                          ></Button>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="917663"
                                        id="917663"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 14,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="773043"
                                          id="773043"
                                          xs={24}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="767862"
                                            id="767862"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              767862,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                display: "block",
                                                fontFamily: "Roboto",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                                color: "#64748B",
                                              } as any
                                            }
                                          ></Label>
                                          <Label
                                            key="976439"
                                            id="976439"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              976439,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 4,
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "20px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="549349"
                                          id="549349"
                                          xs={24}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                          xl={12}
                                          xxl={12}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="879085"
                                            id="879085"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              879085,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                display: "block",
                                                fontFamily: "Roboto",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                                color: "#64748B",
                                              } as any
                                            }
                                          ></Label>
                                          <Label
                                            key="318347"
                                            id="318347"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              318347,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 4,
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "20px",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="437218"
                                        id="437218"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 14,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="949702"
                                          id="949702"
                                          xs={8}
                                          sm={8}
                                          md={8}
                                          lg={8}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Button
                                            key="686446"
                                            id="686446"
                                            label={ReactSystemFunctions.translate(
                                              this.ml,
                                              686446,
                                              "label",
                                              this.defaultML
                                            )}
                                            size="middle"
                                            loading={false}
                                            ghost={false}
                                            block={false}
                                            htmlType="button"
                                            iconPosition="left"
                                            danger={false}
                                            iconLibrary="material"
                                            style={
                                              {
                                                borderTopLeftRadius: 12,
                                                borderTopRightRadius: 12,
                                                borderBottomRightRadius: 12,
                                                borderBottomLeftRadius: 12,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor: "#BFDBFE",
                                                borderStyle: "solid",
                                                backgroundColor: "#EFF6FF",
                                                paddingTop: 10,
                                                paddingRight: 12,
                                                paddingBottom: 10,
                                                paddingLeft: 12,
                                                width: "100%",
                                                fontWeight: 700,
                                                color: "#1D4ED8",
                                              } as any
                                            }
                                          ></Button>
                                        </KCol>
                                        <KCol
                                          key="533943"
                                          id="533943"
                                          xs={8}
                                          sm={8}
                                          md={8}
                                          lg={8}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-center",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="140851"
                                            id="140851"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              140851,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 10,
                                                display: "block",
                                                fontFamily: "Roboto",
                                                fontWeight: 700,
                                                fontSize: "16px",
                                                color: "#0F172A",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="546343"
                                          id="546343"
                                          xs={8}
                                          sm={8}
                                          md={8}
                                          lg={8}
                                          xl={8}
                                          xxl={8}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Button
                                            key="205724"
                                            id="205724"
                                            label={ReactSystemFunctions.translate(
                                              this.ml,
                                              205724,
                                              "label",
                                              this.defaultML
                                            )}
                                            size="middle"
                                            loading={false}
                                            ghost={false}
                                            block={false}
                                            htmlType="button"
                                            iconPosition="left"
                                            danger={false}
                                            iconLibrary="material"
                                            style={
                                              {
                                                borderTopLeftRadius: 12,
                                                borderTopRightRadius: 12,
                                                borderBottomRightRadius: 12,
                                                borderBottomLeftRadius: 12,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor: "#BFDBFE",
                                                borderStyle: "solid",
                                                backgroundColor: "#EFF6FF",
                                                paddingTop: 10,
                                                paddingRight: 12,
                                                paddingBottom: 10,
                                                paddingLeft: 12,
                                                width: "100%",
                                                fontWeight: 700,
                                                color: "#1D4ED8",
                                              } as any
                                            }
                                          ></Button>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="587191"
                                        id="587191"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 14,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="683636"
                                          id="683636"
                                          xs={24}
                                          sm={10}
                                          md={10}
                                          lg={10}
                                          xl={10}
                                          xxl={10}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="243753"
                                            id="243753"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              243753,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderTopLeftRadius: 999,
                                                borderTopRightRadius: 999,
                                                borderBottomRightRadius: 999,
                                                borderBottomLeftRadius: 999,
                                                backgroundColor:
                                                  "rgba(114, 194, 64, 0.2)",
                                                paddingTop: 6,
                                                paddingRight: 10,
                                                paddingBottom: 6,
                                                paddingLeft: 10,
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "16px",
                                                color: "rgba(114, 194, 64, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                        <KCol
                                          key="362825"
                                          id="362825"
                                          xs={24}
                                          sm={14}
                                          md={14}
                                          lg={14}
                                          xl={14}
                                          xxl={14}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-right",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="619795"
                                            id="619795"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              619795,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                display: "block",
                                                fontFamily: "Roboto",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                                color: "#64748B",
                                              } as any
                                            }
                                          ></Label>
                                          <Label
                                            key="426899"
                                            id="426899"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              426899,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 4,
                                                display: "block",
                                                fontFamily: "Montserrat",
                                                fontWeight: 700,
                                                fontSize: "18px",
                                                color: "rgba(68, 142, 247, 1)",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="507151"
                                        id="507151"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 14,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="589880"
                                          id="589880"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="280141"
                                            id="280141"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              280141,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 400,
                                                fontSize: "12px",
                                                color: "rgba(155, 155, 155, 1)",
                                                lineHeight: "20px",
                                              } as any
                                            }
                                          ></Label>
                                          <Label
                                            key="343170"
                                            id="343170"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              343170,
                                              "value",
                                              this.defaultML
                                            )}
                                            writingMode="horizontal"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 4,
                                                display: "block",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "16px",
                                                color: "#475569",
                                              } as any
                                            }
                                          ></Label>
                                        </KCol>
                                      </KRow>
                                      <KRow
                                        key="903762"
                                        id="903762"
                                        align="top"
                                        justify="start"
                                        horizontalGutter={0}
                                        verticalGutter={0}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 14,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                          } as any
                                        }
                                      >
                                        <KCol
                                          key="311439"
                                          id="311439"
                                          xs={24}
                                          sm={24}
                                          md={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          order={0}
                                          pull={0}
                                          push={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "flex-start",
                                              textAlign: "-webkit-left",
                                            } as any
                                          }
                                        >
                                          <Button
                                            key="945047"
                                            id="945047"
                                            label={ReactSystemFunctions.translate(
                                              this.ml,
                                              945047,
                                              "label",
                                              this.defaultML
                                            )}
                                            size="middle"
                                            loading={false}
                                            ghost={false}
                                            block={false}
                                            htmlType="button"
                                            icon="edit"
                                            iconPosition="left"
                                            danger={false}
                                            iconLibrary="material"
                                            style={
                                              {
                                                borderTopLeftRadius: 12,
                                                borderTopRightRadius: 12,
                                                borderBottomRightRadius: 12,
                                                borderBottomLeftRadius: 12,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                borderColor: "#CBD5E1",
                                                borderStyle: "solid",
                                                backgroundColor: "#FFFFFF",
                                                paddingTop: 10,
                                                paddingRight: 14,
                                                paddingBottom: 10,
                                                paddingLeft: 14,
                                                width: "100%",
                                                fontWeight: 700,
                                                color: "#1E3A8A",
                                              } as any
                                            }
                                          ></Button>
                                        </KCol>
                                      </KRow>
                                    </KCol>
                                  </KRow>
                                </KPanel>
                              </KTableColumn>
                            </KTableRow>
                          </KTable>
                        </KCol>
                      </KRow>
                    </KCol>
                  </KRow>
                  <KRow
                    key="941187"
                    id="941187"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                      } as any
                    }
                  >
                    <KCol
                      key="612348"
                      id="612348"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <KPanel
                        key="896884"
                        id="896884"
                        scrolling="hidden"
                        scrollRadius={false}
                        style={
                          {
                            borderTopLeftRadius: 20,
                            borderTopRightRadius: 20,
                            borderBottomRightRadius: 20,
                            borderBottomLeftRadius: 20,
                            borderTopWidth: 1,
                            borderRightWidth: 1,
                            borderBottomWidth: 1,
                            borderLeftWidth: 1,
                            borderColor: "#D9E7FF",
                            borderStyle: "solid",
                            boxShadow: "0px 8px 20px 0px rgba(15,23,42,0.06)",
                            backgroundColor: "#F7FAFF",
                            paddingTop: 18,
                            paddingRight: 18,
                            paddingBottom: 18,
                            paddingLeft: 18,
                          } as any
                        }
                      >
                        <KRow
                          key="715014"
                          id="715014"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                            } as any
                          }
                        >
                          <KCol
                            key="679248"
                            id="679248"
                            xs={16}
                            sm={16}
                            md={16}
                            lg={16}
                            xl={16}
                            xxl={16}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Label
                              key="767694"
                              id="767694"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                767694,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                  color: "#475569",
                                } as any
                              }
                            ></Label>
                          </KCol>
                          <KCol
                            key="640388"
                            id="640388"
                            xs={8}
                            sm={8}
                            md={8}
                            lg={8}
                            xl={8}
                            xxl={8}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                textAlign: "-webkit-right",
                              } as any
                            }
                          >
                            <Label
                              key="32545"
                              id="32545"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                32545,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "20px",
                                  color: "#0F172A",
                                } as any
                              }
                            ></Label>
                          </KCol>
                        </KRow>
                        <KRow
                          key="146497"
                          id="146497"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 12,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                            } as any
                          }
                        >
                          <KCol
                            key="160079"
                            id="160079"
                            xs={16}
                            sm={16}
                            md={16}
                            lg={16}
                            xl={16}
                            xxl={16}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Label
                              key="82772"
                              id="82772"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                82772,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                  color: "#475569",
                                } as any
                              }
                            ></Label>
                          </KCol>
                          <KCol
                            key="895435"
                            id="895435"
                            xs={8}
                            sm={8}
                            md={8}
                            lg={8}
                            xl={8}
                            xxl={8}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                textAlign: "-webkit-right",
                              } as any
                            }
                          >
                            <Label
                              key="82041"
                              id="82041"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                82041,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "20px",
                                  color: "#0F172A",
                                } as any
                              }
                            ></Label>
                          </KCol>
                        </KRow>
                        <KRow
                          key="248333"
                          id="248333"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 12,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                            } as any
                          }
                        >
                          <KCol
                            key="679564"
                            id="679564"
                            xs={16}
                            sm={16}
                            md={16}
                            lg={16}
                            xl={16}
                            xxl={16}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Label
                              key="167763"
                              id="167763"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                167763,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                  color: "#475569",
                                } as any
                              }
                            ></Label>
                          </KCol>
                          <KCol
                            key="980469"
                            id="980469"
                            xs={8}
                            sm={8}
                            md={8}
                            lg={8}
                            xl={8}
                            xxl={8}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                textAlign: "-webkit-right",
                              } as any
                            }
                          >
                            <Label
                              key="821378"
                              id="821378"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                821378,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "20px",
                                  color: "rgba(114, 194, 64, 1)",
                                } as any
                              }
                            ></Label>
                          </KCol>
                        </KRow>
                        <Divider
                          key="567492"
                          id="567492"
                          dashed={false}
                          type="horizontal"
                          style={
                            {
                              borderTopWidth: 1,
                              borderRightWidth: 1,
                              borderBottomWidth: 1,
                              borderLeftWidth: 1,
                              borderColor: "rgba(204, 204, 204, 1)",
                              borderStyle: "solid",
                              paddingTop: 14,
                              paddingBottom: 14,
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        ></Divider>
                        <KRow
                          key="937932"
                          id="937932"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                            } as any
                          }
                        >
                          <KCol
                            key="767967"
                            id="767967"
                            xs={14}
                            sm={14}
                            md={14}
                            lg={14}
                            xl={14}
                            xxl={14}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Label
                              key="399419"
                              id="399419"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                399419,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  display: "block",
                                  fontFamily: "Montserrat",
                                  fontWeight: 700,
                                  fontSize: "16px",
                                  color: "#0F172A",
                                } as any
                              }
                            ></Label>
                          </KCol>
                          <KCol
                            key="557089"
                            id="557089"
                            xs={10}
                            sm={10}
                            md={10}
                            lg={10}
                            xl={10}
                            xxl={10}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                textAlign: "-webkit-right",
                              } as any
                            }
                          >
                            <Label
                              key="363029"
                              id="363029"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                363029,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  display: "block",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "20px",
                                  color: "rgba(68, 142, 247, 1)",
                                } as any
                              }
                            ></Label>
                          </KCol>
                        </KRow>
                      </KPanel>
                    </KCol>
                  </KRow>
                </div>
                <Footer
                  key="-3"
                  id="ordersummary_footer"
                  style={
                    {
                      borderTopWidth: 1,
                      borderColor: "#E2E8F0",
                      borderStyle: "solid",
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      boxShadow: "0px -6px 18px 0px rgba(15,23,42,0.08)",
                      backgroundColor: "#FFFFFF",
                      paddingTop: 12,
                      paddingRight: 16,
                      paddingBottom: 12,
                      paddingLeft: 16,
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "15px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                >
                  <KRow
                    key="635587"
                    id="635587"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KCol
                      key="309146"
                      id="309146"
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      xxl={12}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <Button
                        key="864519"
                        id="864519"
                        label={ReactSystemFunctions.translate(
                          this.ml,
                          864519,
                          "label",
                          this.defaultML
                        )}
                        size="middle"
                        loading={false}
                        ghost={false}
                        block={false}
                        htmlType="button"
                        icon="credit_card"
                        iconPosition="left"
                        danger={false}
                        iconLibrary="material"
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            borderTopWidth: 2,
                            borderRightWidth: 2,
                            borderBottomWidth: 2,
                            borderLeftWidth: 2,
                            borderColor: "rgba(0, 0, 0, 0.2)",
                            borderStyle: "solid",
                            backgroundColor: "rgba(244, 244, 244, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 8,
                            paddingRight: 16,
                            paddingBottom: 8,
                            paddingLeft: 16,
                            alignItems: "center",
                            textAlign: "-webkit-center",
                            display: "block",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "16px",
                            color: "rgba(0, 0, 0, 1)",
                          } as any
                        }
                      ></Button>
                    </KCol>
                    <KCol
                      key="949072"
                      id="949072"
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      xxl={12}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <Button
                        key="374235"
                        id="374235"
                        label={ReactSystemFunctions.translate(
                          this.ml,
                          374235,
                          "label",
                          this.defaultML
                        )}
                        size="middle"
                        loading={false}
                        ghost={false}
                        block={false}
                        htmlType="button"
                        icon="shopping_cart"
                        iconPosition="left"
                        danger={false}
                        iconLibrary="material"
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            borderTopWidth: 2,
                            borderRightWidth: 2,
                            borderBottomWidth: 2,
                            borderLeftWidth: 2,
                            borderColor: "transparent",
                            borderStyle: "solid",
                            backgroundColor: "rgba(0, 0, 0, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 8,
                            paddingRight: 16,
                            paddingBottom: 8,
                            paddingLeft: 16,
                            alignItems: "center",
                            textAlign: "-webkit-center",
                            display: "block",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "16px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Button>
                    </KCol>
                  </KRow>
                  <KRow
                    key="31471"
                    id="31471"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        backgroundPosition: "left",
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "center",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="505342"
                      id="505342"
                      xs={5}
                      sm={5}
                      md={5}
                      lg={5}
                      xl={5}
                      xxl={5}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "center",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <VerticalStack
                        key="499247"
                        id="499247"
                        direction="vertical"
                        size={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            textAlign: "-webkit-center",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Icon
                          key="699816"
                          id="699816"
                          iconName="home_filled"
                          iconLibrary="material"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "24px",
                              color: "rgba(155, 155, 155, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <Label
                          key="185241"
                          id="185241"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            185241,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "11px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        ></Label>
                      </VerticalStack>
                    </KCol>
                    <KCol
                      key="520584"
                      id="520584"
                      xs={5}
                      sm={5}
                      md={5}
                      lg={5}
                      xl={5}
                      xxl={5}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <VerticalStack
                        key="321396"
                        id="321396"
                        direction="vertical"
                        size={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            textAlign: "-webkit-center",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Icon
                          key="712786"
                          id="712786"
                          iconName="person_3"
                          iconLibrary="material"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "24px",
                              color: "rgba(155, 155, 155, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <Label
                          key="831255"
                          id="831255"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            831255,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "11px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        ></Label>
                      </VerticalStack>
                    </KCol>
                    <KCol
                      key="672400"
                      id="672400"
                      xs={5}
                      sm={5}
                      md={5}
                      lg={5}
                      xl={5}
                      xxl={5}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <VerticalStack
                        key="721909"
                        id="721909"
                        direction="vertical"
                        size={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            textAlign: "-webkit-center",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Icon
                          key="360032"
                          id="360032"
                          iconName="search"
                          iconLibrary="material"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "24px",
                              color: "rgba(155, 155, 155, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <Label
                          key="236745"
                          id="236745"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            236745,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "11px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        ></Label>
                      </VerticalStack>
                    </KCol>
                    <KCol
                      key="620029"
                      id="620029"
                      xs={5}
                      sm={5}
                      md={5}
                      lg={5}
                      xl={5}
                      xxl={5}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <VerticalStack
                        key="127071"
                        id="127071"
                        direction="vertical"
                        size={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            textAlign: "-webkit-center",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Icon
                          key="535341"
                          id="535341"
                          iconName="local_grocery_store"
                          iconLibrary="material"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "24px",
                              color: "rgba(68, 142, 247, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <Label
                          key="309046"
                          id="309046"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            309046,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "11px",
                              color: "rgba(68, 142, 247, 1)",
                            } as any
                          }
                        ></Label>
                      </VerticalStack>
                    </KCol>
                    <KCol
                      key="582087"
                      id="582087"
                      xs={4}
                      sm={4}
                      md={4}
                      lg={4}
                      xl={4}
                      xxl={4}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <VerticalStack
                        key="933630"
                        id="933630"
                        direction="vertical"
                        size={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            textAlign: "-webkit-center",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Icon
                          key="389838"
                          id="389838"
                          iconName="menu_open"
                          iconLibrary="material"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "24px",
                              color: "rgba(155, 155, 155, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <Label
                          key="279449"
                          id="279449"
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            279449,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-center",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "11px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        ></Label>
                      </VerticalStack>
                    </KCol>
                  </KRow>
                </Footer>
              </div>
            </Form>
          </KuikaTabOrderProvider>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(mapStateToProps, mapDispatchToProps)(OrderSummary_Screen)
        )
      )
    )
  )
);
export { tmp as OrderSummary_Screen };
//export default tmp;
//export { tmp as OrderSummary_Screen };
